import { gql } from "@apollo/client";

export const GET_CONTRATOS_SEARCH = gql`
query GET_CONTRATOS_SEARCH(
    $filter: ContratoSearchFilterInput! 
) {
    contratosSearch(filter: $filter)
    {
        success,
        error,
        valorEsperado {          
          idEvaluacion,
          idDelegacion,
          nombre,
          apellido,
          razonSocial,
          fechaAlta,
          fechaDesde,
          fechaHasta,
          precioDiario,
          estadoCrediticioE,
          estadoProfesionalE,
          estadoPaciente,
          estadoEvaluacionComercial,
          descPlan,
          tipo,
          idEstadoEvaluacion,
          descEstadoEvaluacion,
          diasCO,
          idNIngreso,
          idPrePaciente
        }
    }
}`;